import React from "react";
import { Helmet } from "react-helmet";

const Seo = ({ title, description, keywords, image, url }) => {
  return (
    <Helmet>
      <title>{title || "NxtEye – The New Language of Luxury Fashion"}</title>
      <meta
        name="description"
        content={
          description ||
          "NxtEye transforms your retail cameras into emotional intelligence powered by Personality AI."
        }
      />
      <meta
        name="keywords"
        content={
          keywords ||
          [
            "NxtEye",
            "AI",
            "Retail AI",
            "Luxury Retail",
            "Luxury Fashion Tech",
            "Behavioral Analytics",
            "Emotional Intelligence",
            "Personality AI",
            "In-store Analytics",
            "Fashion Innovation",
            "Customer Behavior",
            "Retail Intelligence",
            "Smart Stores",
            "Cognitive AI",
            "Real-time Insights",
            "Retail Technology",
            "Customer Journey",
            "Conversion Optimization",
            "GDPR Compliant AI",
            "AI Nudges",
            "Privacy-First Analytics",
          ].join(", ")
        }
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={image || "https://nxteye.com/og-image.jpg"}
      />
      <meta property="og:url" content={url || "https://nxteye.com"} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default Seo;
